import { Icon } from 'components/Icon';
import { classNames } from 'libs/react';
import { React } from 'libs/react';
import { LanguageSelectOption } from './LanguageSelectOption';
import './LanguageSelect.scss';
/**
 * @component LanguageSelect
 * @since 1.0.0
 */
export function LanguageSelect(props) {
    const { style, current, options, onSelect, onMouseEnter, onMouseLeave } = Object.assign({ style: 'normal' }, props);
    const className = classNames('language-select', 'language-select--' + style, props.className);
    return (React.createElement("div", { className: className },
        React.createElement("div", { className: "language-select-content" },
            React.createElement("div", { className: "language-select-value" }, current.name),
            React.createElement("div", { className: "language-select-arrow" },
                React.createElement(Icon, { value: "chevron-down" }))),
        React.createElement("div", { className: "language-select-options" }, options.map((option) => (React.createElement(LanguageSelectOption, { key: option.code, value: option, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onSelect: onSelect }))))));
}
